enum HouseholdLimitReset {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    SemiAnnually = 'SemiAnnually',
    Annually = 'Annually',
}

export default HouseholdLimitReset;
